// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"33":"20b9dfe4","356":"efe5c0a4","384":"ea6b820d","412":"ea6b820d","663":"20e887f7","788":"8d0b983f"}[chunkId] + ".chunk.css";
};